export class StateOption {
    constructor(state?: string, majorlocation?: string, major_loc_id?: string) {
        this.state = state;
        this.majorlocation = majorlocation;
        this.major_loc_id = major_loc_id;
    }

    state: string;
    majorlocation: string;
    major_loc_id: string;
}